import React from "react";
import { Icon } from "../icons";

/**
 * Shown when the dashboard could not load from the backend. The board is never
 * replaced with sample data: a save on top of that would overwrite the
 * coordinator's real escalations, reminders and notes.
 */
export const LoadErrorScreen = ({ error, onRetry }) => (
  <div className="mc-ops-root" lang="en">
    <div className="mc-load-error">
      <div className="mc-load-error-icon">
        <Icon name="alert" />
      </div>
      <h2>Could not load the dashboard</h2>
      <p>
        The backend did not answer, so nothing is shown rather than out-of-date or
        sample data. Check your connection and try again.
      </p>
      {error ? <code>{error}</code> : null}
      <button type="button" className="btn primary" onClick={onRetry}>
        <Icon name="inprogress" />
        Try again
      </button>
    </div>
  </div>
);
